import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=1974600e&scoped=true&"
import script from "./ProfilePage.vue?vue&type=script&lang=js&"
export * from "./ProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePage.vue?vue&type=style&index=0&id=1974600e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974600e",
  null
  
)

export default component.exports